import FooterContent from "./FooterContent";
import PropTypes from "prop-types";
import styles from "./Footer.module.css";

const Footer = ({ className = "" }) => {
  return (
    <section className={[styles.footer, className].join(" ")}>
      <FooterContent />
    </section>
  );
};

Footer.propTypes = {
  className: PropTypes.string,
};

export default Footer;
